// extracted by mini-css-extract-plugin
export default {"container":"styles__container___yhdLm","image":"styles__image___jCLqp","title":"styles__title___NcccV","big":"styles__big___ty70q styles__title___NcccV"};